import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ITinduxAuthModel, ITinduxResponse } from 'src/app/models/tindux/tindux.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TinduxAuthService {
  private readonly apiURL = environment.ApiConecta;
  constructor(private http: HttpClient) { }

  public auth(body: ITinduxAuthModel): Observable<ITinduxResponse> {
    return this.http.post<ITinduxResponse>(`${this.apiURL}training/autenticacion`,body);
  }

}
